import { Card, CardContent, Avatar, Typography } from "@mui/material";
import { FC, ReactNode } from "react";
import { TileEntryLink, TileContent } from "../dashboard/entryTiles";
import BallotIcon from '@mui/icons-material/Ballot';
import FenceIcon from '@mui/icons-material/Fence';
import RunningWithErrorsIcon from '@mui/icons-material/RunningWithErrors';


const disabledSx = {
  '& .MuiAvatar-root': {
    bgcolor: 'action.disabledBackground',
    '& .MuiSvgIcon-root': {
      color: 'action.disabled'
    },
  },
  '& > h6': {
    color: 'text.disabled'
  }
}

export const DataCatalogTile: FC = () => {
  return (
    <TileEntryLink to="/governance/data-catalog" sx={{cursor: 'pointer'}} >
      <Card>
        <CardContent>
          <TileContent>
            <Avatar>
              <BallotIcon />
            </Avatar>
            <Typography variant="h6">
              Data Catalog
            </Typography>
          </TileContent>
        </CardContent>
      </Card>
    </TileEntryLink>
  )
}

export const DataClassificationTile: FC = () => {
  return (
    <TileEntryLink to="/encryption/mappings" sx={{cursor: 'pointer'}} >
      <Card>
        <CardContent>
          <TileContent>
            <Avatar>
              <RunningWithErrorsIcon />
            </Avatar>
            <Typography variant="h6">
              Data Classification
            </Typography>
          </TileContent>
        </CardContent>
      </Card>
    </TileEntryLink>
  )
}
export const DataOwnershipTile: FC = () => {
  return (
    <TileEntryLink to="/governance/data-ownership" sx={{cursor: 'pointer'}} >
      <Card>
        <CardContent>
          <TileContent>
            <Avatar>
              <FenceIcon />
            </Avatar>
            <Typography variant="h6">
              Data Ownership
            </Typography>
          </TileContent>
        </CardContent>
      </Card>
    </TileEntryLink>
  )
}

export const PlaceholderTile: FC<{name: string, icon: ReactNode}> = ({ name, icon }) => {
  return (
    <TileEntryLink to="/governance/dashboard" sx={{cursor: 'default'}} >
      <Card>
        <CardContent>
          <TileContent
            sx={disabledSx}
          >
            <Avatar>
              {icon}
            </Avatar>
            <Typography variant="h6">
              {name}
            </Typography>
          </TileContent>
        </CardContent>
      </Card>
    </TileEntryLink>
  )
}

